import { createTheme } from '@mui/material/styles'; 

const createAppTheme = ({ primary, light, medium, secondary, whitegreen, shadow }) =>
  createTheme({
    mode: 'light',
    palette: {
      primary: {
        main: primary,
        contrastText: '#fff',
      },
      light: { 
        main: light,
        contrastText: '#fff',
      },
      medium: { 
        main: medium,
        contrastText: '#fff',
      },
      secondary: {
        main: secondary,
        contrastText: '#fff',
      },
      white: {
        main: '#ffffff',
        contrastText: '#49C145',
      },
      error: {
        main: '#dd4952',
      },
      warning: {
        main: '#ffa726',
      },
      info: {
        main: '#a4a4a4',
        contrastText: '#fff',
      },
      success: {
        main: '#66bb6a',
      },
      colors:{
          white: '#ffffff',
          straw: '#f1ddba',
          whitegreen: whitegreen,
          whiteness: 'rgba(255,255,255, .4)',
          black: '#000000',
          grey: '#4C4C4C',
          backgroundgrey: '#F7F7F7',
          lightgrey: '#A4A4A4',
          shadow: shadow,
          lightshadow: 'rgba(112,112,112,.06)'
      }
    },
  });

export const themes = {
  nursing: createAppTheme({
    primary: '#0f8f86',
    light: '#a1ddd7',
    medium: '#36b2a8',
    secondary: '#36b2a8',
    whitegreen: '#dff3f1',
    shadow: 'rgba(13, 103, 97, .16)',
  }),
  jadePastel: createAppTheme({
    primary: '#5aa88a',
    light: '#bfe6d6',
    medium: '#8bc9b1',
    secondary: '#73b89d',
    whitegreen: '#eaf5ef',
    shadow: 'rgba(43, 95, 79, .16)',
  }),
};

export const theme = themes.nursing;

export const getThemeByKey = (themeKey = 'nursing') => themes[themeKey] || themes.nursing;
